import React from "react";
import styled from "styled-components";
import Highlight2 from "./images/highlight2.png";
import Highlight3 from "./images/highlight3.png";
import Image from "next/image";
const DivFlex = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 50px;
  margin-top: 20px;

  @media screen and (max-width: 1280px) {
    gap: 27px;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;
const ImgHigh = styled.div`
  @media screen and (max-width: 1280px) {
    /* width: 40%; */
    margin: 0 auto;

    img{
        width: 500px;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;

    img{
        width: 100%;
    }
  }
`;
const HeaderH = styled.p`
  margin: 0;
  text-align: left;
  font-family: Roboto;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 44px;
  color: #000000;
  margin-bottom: 30px;

  @media screen and (max-width: 1280px) {
    font-size: 18px;
    width: 611px;
  }
  @media screen and (min-width: 1400px) {
    width: 680px;
  }
  @media screen and (max-width: 767px) {
    text-align: initial;
    width: auto;
  }
`;
const ParaH = styled.p`
  margin: 0;
  text-align: left;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
  color: #454545;
  margin-bottom: 10px;

  @media screen and (max-width: 1280px) {
    font-size: 17px;
    width: 611px;
  }
  @media screen and (max-width: 767px) {
    width: auto;
  }
`;
const KeyHead = styled.div`
font-size: 36px;
font-weight: 700;
line-height: 44px;
color: #FF7624;
margin-top: 35px;
`;

const KeyHeadText = styled.div`
font-family: Roboto;
font-size: 20px;
font-weight: 700;
line-height: 29px;
padding-bottom: 5px;
`;

const NormalText = styled.div`
font-family: Roboto;
font-size: 20px;
font-weight: 400;
line-height: 29px;
color: #454545;
margin-top: 20px;
margin-bottom:20px;
`;

const ContLi = styled.li`
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 33px;
  color: #454545;
  margin-bottom: 35px;
  @media screen and (max-width: 1280px) {
    font-size: 17px;
    margin-left: 18px;
  }

`;
const Divider = styled.div`
border-bottom: 1px solid #C8C7C7;
    width: 100%;
    padding: 17px 0px;`;

const ThirdHead = styled.div`
font-family: Roboto;
font-size: 31px;
font-weight: 500;
line-height: 44px;
color: #000000;
`;
export default function TempHighlightsSecond() {
  return (
    <div>
      <DivFlex>
        <div>
          <KeyHead>Haply Robotics</KeyHead>
          <NormalText>
            The MinVerse by Haply Robotics has emerged as a standout in
            innovation at CES® 2025, where it claimed the prestigious ‘Best of
            Innovation’ award in the Metaverse category and was honored in XR
            Technologies & Accessories. This compact, touch-enabled device
            redefines immersive experiences in the metaverse. Designed with
            portability and precision in mind, the MinVerse offers users a level
            of tactile feedback and accuracy that allows seamless, lifelike
            interaction within virtual spaces.
          </NormalText>
          <NormalText>
            Using the MinVerse 3D mouse by Haply Robotics for digital sculpting
            experience the texture, depth, and precision control needed to bring
            virtual models to life.
          </NormalText>
          <KeyHeadText>MinVerse Key Highlights</KeyHeadText>
          <ul>
            <ContLi>
              <b>Portable and Customizable:</b> Compact design with a VerseGrip
              handle for easy accessory swaps, making it versatile for various
              3D tasks.
            </ContLi>
            <ContLi>
              <b>Realistic Haptic Feedback:</b> Delivers lifelike textures and
              resistances, enabling true-to-life interaction within virtual
              spaces.
            </ContLi>
            <ContLi>
              <b>Metaverse Game-Changer:</b> Sets a new standard for immersive,
              tactile experiences, ideal for 3D design, digital art, and gaming.
            </ContLi>
          </ul>
        </div>
        <ImgHigh>
          <Image
            src={Highlight2}
            alt="Here are a few highlights to look out for in CES 2024:"
          />
        </ImgHigh>
      </DivFlex>
      <Divider></Divider>
      <DivFlex>
        <div>
          <KeyHead>Wipro</KeyHead>
          <ThirdHead>
            New Era of Car Innovation with Wipro’s CloudCarAI platform:
          </ThirdHead>
          <NormalText>
            The gateway to an enhanced, personalized vehicle experience. From
            seamless OTA updates via TV signals to smart energy management for
            electric and hybrid vehicles, the platform transforms every journey
            and unlocks new monetization avenues through cloud-accelerated
            automation.
          </NormalText>
          <NormalText>
            CloudCarAI is where technology meets the road, paving the way for
            smarter driving.
          </NormalText>
        </div>
        <ImgHigh>
          <Image
            src={Highlight3}
            alt="Here are a few highlights to look out for in CES 2024:"
          />
        </ImgHigh>
      </DivFlex>
    </div>
  );
}
